module.exports = __webpack_public_path__ + "static/step-2-2a-2-cron-gui-35e10a09d2ef320bb339cbc86b65dbb9.png";